<template>
  <div>
    <div class="main-header">
      <h3>{{$t('admin.modules.all_permissions')}}</h3>
      <a @click="add">{{$t('admin.modules.add_module')}}</a>
    </div>
    <table-panel :table="table"></table-panel>
    <pop-up v-model="show">
      <form @submit.prevent="save()" class="form-field">
        <section>
          <span>{{$t('admin.modules.method_name')}}</span>
          <input type="text" v-model="item.url">
        </section>
        <section>
          <span>{{$t('admin.modules.parent_module')}}</span>
          <input type="text" v-model="item.parent_name">
        </section>
        <section>
          <span>{{$t('admin.common.operation')}}</span>
          <input type="text" v-model="item.self_name">
        </section>
        <button>{{$t('global.save')}}</button>
      </form>
    </pop-up>
    <pop-up v-model="show2">
      <form @submit.prevent="save2()" class="form-field">
        <section>
          <span>{{$t('admin.modules.subordinate_module')}}</span>
          <v-select v-model="item2.parent_id" :options="modules" :placeholder="$t('admin.modules.search_module')" searchable local-search></v-select>
        </section>
        <section>
          <span>url</span>
          <input type="text" v-model="item2.url">
        </section>
        <section>
          <span>{{$t('admin.modules.name')}}</span>
          <input type="text" v-model="item2.name">
        </section>
        <button>{{$t('global.save')}}</button>
      </form>
    </pop-up>
  </div>
</template>

<script>
  import OperatePanel from '@/components/operatePanel.vue'
  import TablePanel from '@/components/tablePanel.vue'
  import {list} from '@/server/mixins.js'
  import PopUp from '@/components/popup.vue'
  import VSelect from '@/components/vselect.vue'

  function Modules (item,name) {
    if (item) {
      this.id = item.id
      this.parent_id = item.parent_id || undefined
      this.url = item.url
      this.name = name
    }else{
      this.parent_id = ''
      this.url = ''
      this.name = ''
    }
  }

  export default {
    name: "Modules",
    components:{OperatePanel,TablePanel,PopUp,VSelect},
    data () {
      return {
        show:false,
        show2:false,
        modules:[],
        table:{
          thead:[
              {name:this.$t('admin.modules.parent_module'),attr:'parent_name'},
              {name:this.$t('admin.modules.module'),attr:'name'},
              {name:this.$t('admin.modules.method_name'),attr:'url'},
              {name:this.$t('admin.common.operation'),buttons:[
                  {name:this.$t('admin.common.compile'),event:this.modify}
              ]}
          ],
          tbody:[],
          tfoot:true,
        },
        item:{},
        item2:new Modules()
      }
    },
    methods:{
      modify (data) {
        this.item = JSON.parse(JSON.stringify(data))
        this.show = true
      },
      add () {
        this.items = new Modules()
        this.show2 =true
      },
      save2 () {
        this.$http.post('/ams/page/save',JSON.stringify(this.item2)).then(()=>{
          this.getList()
          this.show2 = false
        })
      },
      save () {
        var list = [new Modules(this.item,this.item.self_name)]
        function compare (item,name) {
          if (item.name !== name) {
            list.push(new Modules(item,name))
          }
        }
        compare(this.item.parent,this.item.parent_name)
        Promise.all(list.map(v =>this.$http.post('/ams/page/save',JSON.stringify(v)))).then(()=>{
          this.getList()
          this.show = false
        })
      },
      getList () {
        var idMap = {}
        var modules = []
        return this.$http.get('/ams/page/list',{order:'id',sort:'asc'}).then(res=>{
          var data = res.data.data || []
          //添加模块下拉表
          this.modules = data.map(v => {
            return {
              name:v.name,
              value:v.id
            }
          })
          data.forEach(v => idMap[v.id] = v)
          data.forEach(v =>{
            if (v.parent_id !== 0) {
              v.self_name = v.name
              v.parent_name = idMap[v.parent_id].name
              v.parent = idMap[v.parent_id]
              modules.push(v)
            }
          })
          this.table.tbody = modules
        })
      },
    },
    mounted() {
      this.getList()
    }
  }
</script>
